import React, { useEffect } from 'react';
import { Redirect, Route, Switch } from "react-router-dom";
import { useStoreState, useStoreActions } from "easy-peasy";
import Landing from "./sections/landing";
import Approved from "../global-elements/approved/approved2";
import Declined from "../global-elements/declined";
import '../../../assets/prequal/newDesign.css';
import Error404 from '../../../components/systempages/error404/Error404';
import GrandBankPage from "../global-elements/grandbank/grandbankPage";
import DeclinedTemporal from "../global-elements/declinedTemporal";
import LinkBankAccount from '../linkBankAccount/linkBankAccount';
import { InactiveDetection } from '../../../services/inactiveDetection';
import ApprovedGrandBank from '../global-elements/approved/approved_grandbank';
import PDFTerms from '../global-elements/PDFTerms';
import { PRODUCT } from '../../../models/websiteTypesConstants';

function Layout() {

    const resultStep        = useStoreState(state => state.displayResult);
    const MainPath          = useStoreState(state => state.siteSettingsModel.MainPath);
    const setting           = useStoreState(state => state.siteSettingsModel);
    const setProductPath    = useStoreActions(actions => actions.siteSettingsModel.setMainPath);
    
    useEffect(() => {
        InactiveDetection.setInactiveTitle(null);
    }, []);

    useEffect(() => {
        document.querySelector("title").textContent = `${setting.brandSettings.ProductName || ""} - Mastercard`;
        InactiveDetection.setTitle(`${setting.brandSettings.ProductName || ""} - Mastercard`);
        if(MainPath === "/"){
            setProductPath((window.location.pathname.split("/")[1] === '') ? "/" : "/" + window.location.pathname.split('/')[1] + "/") 
        }
    },[setting.brandSettings.ProductName, MainPath, setProductPath]);
    return (
        <Switch>
            <Route path="/" render={() => (MainPath !== "/") ? <Redirect to={"/" + MainPath + window.location.search} /> : <Error404 />} exact />
            <Route path="/:MainPath/getTerms/:productCode" component={() => <PDFTerms />} exact />
            <Route path="/:MainPath" render={() => (MainPath !== "/" && "/" + window.location.pathname.split('/')[1] + "/" === MainPath) ? <Landing /> : <Error404 />} exact />
            <Route path="/:MainPath/approved" render={() => (resultStep) ? (setting.brandSettings.ProductName === PRODUCT.Grand.bank ? <ApprovedGrandBank /> : <Approved />) : <Redirect to={"/" + window.location.pathname.split('/')[1] + window.location.search} />} exact />
            {/* Terms page No form */}
            <Route path="/:MainPath/decision" render={() => (resultStep) ? <Declined /> : <Redirect to={"/" + window.location.pathname.split('/')[1] + window.location.search} />} exact/>
            <Route path="/:MainPath/grandbank" render={() => (resultStep) ? <GrandBankPage /> : <Redirect to={"/" + window.location.pathname.split('/')[1] + window.location.search} />} exact/>
            <Route path="/:MainPath/pendinfo" render={() => (resultStep) ? <DeclinedTemporal /> : <Redirect to={"/" + window.location.pathname.split('/')[1] + window.location.search} />} exact />
            <Route path="/:MainPath/link-account" render={() => (resultStep) ? <LinkBankAccount /> : <Redirect to={"/" + window.location.search} />} exact />
            <Route  render={() => <Error404 />}  />
        </Switch>
    );
}

export default Layout;